import { ReactNode } from 'react'

import ULink from '@/components/Link/ULink'
import { ProductType } from '@/types/product'

export default function ProductCardLink({
  nextLink = true,
  product,
  children,
}: {
  nextLink?: boolean
  product: ProductType
  children: ReactNode
}) {
  return (
    <ULink
      nextLink={nextLink}
      style={{ width: '100%', height: '100%', display: 'flex' }}
      href={`/products/${product.productId}`}
    >
      {children}
    </ULink>
  )
}
